"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
//@ts-nocheck
/**
 * pageopt
 */
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var pageopt = {
    urlkeyvalues: {
        pagenumber: "pageNumber",
        pagesize: "pageSize",
        sortname: "sortColumns",
        sortorder: "sortTypes"
    },
    columns: {
        scgz: {
            TRADE_DATE: emfield.date,
            XG: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    var detailLink = "/gzfx/list.html?date=" + date;
                    return ("<a class=\"red\" href=" + detailLink + " style='color:red;'>\u8BE6\u7EC6</a>");
                },
            },
            PE_TTM_AVG: {
                formatter: { num: 2 }
            },
            TOTAL_SHARES: {
                formatter: { zoom: 4, num: 2 }
            },
            FREE_SHARES: {
                formatter: { zoom: 4, num: 2 }
            },
            TOTAL_MARKET_CAP: {
                formatter: { zoom: 4, num: 2 }
            },
            FREE_MARKET_CAP: {
                formatter: { zoom: 4, num: 2 }
            },
            LISTING_ORG_NUM: {
                formatter: { num: 0 }
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2, omit: false });
                }
            },
            CHANGE_RATE: {
                formatter: { showcolor: true }
            }
        },
        gggz: {
            TRADE_DATE: emfield.date,
            SECURITY_CODE: emfield.code,
            SECURITY_NAME_ABBR: emfield.name,
            XG: {
                formatter: function (value, item, i, field) {
                    var detailLink = "/gzfx/detail/" + item.SECURITY_CODE + ".html";
                    var gb_Link = "//guba.eastmoney.com/topic," + item.SECURITY_CODE + ".html";
                    var gg_Link = "/stockdata/" + item.SECURITY_CODE + ".html";
                    return "\n                    <a href=" + detailLink + " style='color:red;cursor:pointer;'>\u8BE6\u7EC6</a>\n                    <a href=" + gg_Link + ">\u6570\u636E</a>\n                    <a href=" + gb_Link + ">\u80A1\u5427</a>\n                    ";
                },
            },
            CLOSE_PRICE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { showcolor: true, colorvalue: item.CHANGE_RATE, num: 2, omit: false });
                }
            },
            CHANGE_RATE: { formatter: { showcolor: true } },
            PE_TTM: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PE_LAR: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PB_MRQ: {
                formatter: { num: 2 }
            },
            PEG_CAR: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PS_TTM: {
                formatter: { num: 2 }
            },
            PCF_OCF_TTM: {
                formatter: { num: 2 }
            },
            BOARD_NAME: {
                formatter: function (value, item, i, field) {
                    if (value) {
                        return "<a href=\"/gzfx/list.html?hyName=" + encodeURIComponent(value) + "\" target=\"_blank\">" + value + "</a>";
                    }
                    return '-';
                }
            }
        },
        hygz: {
            TRADE_DATE: emfield.date,
            XG: {
                formatter: function (value, item, i, field) {
                    var detailLink = "/gzfx/hy/" + item.BOARD_CODE + ".html";
                    var gb_Link = "//guba.eastmoney.com/list,BK" + (item.ORIGINALCODE.length == 4 ? item.ORIGINALCODE : ('0' + item.ORIGINALCODE)) + ".html";
                    var hy_detail_Link = "//quote.eastmoney.com/center/boardlist.html#boards-BK" + (item.ORIGINALCODE.length == 4 ? item.ORIGINALCODE : ('0' + item.ORIGINALCODE)) + "1";
                    return "\n                    <a href=" + detailLink + " style='color:red;cursor:pointer;'>\u8BE6\u7EC6</a>\n                    <a href=" + hy_detail_Link + ">\u884C\u4E1A\u884C\u60C5</a>\n                    <a href=" + gb_Link + ">\u80A1\u5427</a>\n                    ";
                }
            },
            PE_TTM: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PE_LAR: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PB_MRQ: {
                formatter: { num: 2 }
            },
            PEG_CAR: {
                formatter: function (value, item, i, field) {
                    return value < 0 ? "-" : fieldtools_1["default"].fieldfmt(value, { num: 2 });
                }
            },
            PCF_OCF_TTM: {
                formatter: { num: 2 }
            },
            PS_TTM: {
                formatter: { num: 2 }
            },
            MARKET_CAP_VAG: {
                formatter: { zoom: -8, num: 2 }
            },
            NUM: { formatter: { num: 0 } },
            LOSS_COUNT: { formatter: { num: 0 } }
        }
    }
};
window.pageopt = pageopt;
exports["default"] = pageopt;
